kombi.cleaveMask = function () {
  document.querySelectorAll("input.cleave").forEach((item) => {
    let opts = {
      creditCard: this.getBoolAttr(item, "data-credit-card", false),
      phone: this.getBoolAttr(item, "data-phone", false),
      phoneRegionCode: item.getAttribute("data-phone-region-code") || "br",
      date: this.getBoolAttr(item, "data-date", false),
      datePattern: (item.getAttribute("data-date-pattern") || "d/m/Y").split(
        "/"
      ),
      dateMin: item.getAttribute("data-date-min"),
      dateMax: item.getAttribute("data-date-max"),
      time: this.getBoolAttr(item, "data-time", false),
      timePattern: (item.getAttribute("data-time-pattern") || "h:m").split(":"),
      timeFormat: item.getAttribute("data-time-format") || "24",
      blocks: item
        .getAttribute("data-blocks")
        ?.split("|")
        .map((x) => parseInt(x)),
      delimiter: item.getAttribute("data-delimiters"),
      delimiters: item.getAttribute("data-delimiters")?.split("|"),
      uppercase: this.getBoolAttr(item, "data-uppercase", false),
      lowercase: this.getBoolAttr(item, "data-lowercase", false),
      numeral: this.getBoolAttr(item, "data-numeral", false),
      numericOnly: this.getBoolAttr(item, "data-numeric-only", false),
      numeralThousandsGroupStyle: item.getAttribute(
        "data-numeral-thousands-group-style"
      ),
      numeralDecimalMark: item.getAttribute("data-numeral-decimal-mark") || ",",
      prefix: item.getAttribute("data-prefix"),
      tailPrefix: this.getBoolAttr(item, "data-tail-prefix", false),
    };
    new Cleave(item, opts);
  });
};
